import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource } from "kea-resource";
const controller = rpcController("Contabilidad");

export const Contabilidad = cacheResource({
    /**Obtiene una póliza */
    GetPoliza: async (idPoliza: number): Promise<models.PolizaContableDto> => await controller('GetPoliza', { idPoliza }),

    /**Consulta un conjunto de polizas */
    ConsultarPolizas: async (filtro: models.FiltroPolizaContable): Promise<models.PolizaContableDto[]> => await controller('ConsultarPolizas', {}, filtro),

    /**Consulta un conjunto de polizas */
    ReenviarPoliza: async (idPoliza: number): Promise<string> => await controller('ReenviarPoliza', { idPoliza }),
});


// WEBPACK FOOTER //
// ./app/resources/items/contabilidad.tsx